import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { textSize } from '@portal/kit/pkg/styles'

const confirmationContentStyles = createUseStyles(theme => ({
  confirmationItem: {
    marginBottom: 16,
  },
  psk: {
    marginBottom: 16,
  },
  confirmationText: {
    ...textSize(14, 19),
    marginBottom: 16,
  },
  [config.mediaQueries.tabletPortrait]: {
    confirmationText: {
      marginBottom: 32,
    }
  },
  renewalConfirmationText: {
    ...textSize(14, 19),
    marginBottom: 10,
  }
}))

export default confirmationContentStyles
